/**
 * 薬品プレースホルダーのパターン定義
 * 【】で囲まれた以下のパターンを認識:
 * - 【xxx錠】（xxxは2文字以上）
 * - 【xxx薬】（xxxは2文字以上）
 * - 【薬剤】、【薬剤1】などの既存パターン
 * - その他の【】で囲まれた文字列
 */
export const MEDICATION_PLACEHOLDER_PATTERN =
  '【(?:[^】錠薬]{2,}(?:錠|薬)|薬剤(?:[0-9]+)?|[^】]+)】'

/**
 * 薬品認識用の正規表現を作成
 * @param medInfo 薬品名の配列
 * @returns 薬品プレースホルダーと実際の薬品名を認識する正規表現
 */
export const createMedicationRegex = (medInfo: string[]): RegExp => {
  const escapedMeds = medInfo
    .map((med) => med.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .join('|')

  return new RegExp(
    `${MEDICATION_PLACEHOLDER_PATTERN}${escapedMeds ? `|${escapedMeds}` : ''}`,
    'g'
  )
}
